import { useEffect } from 'react';

const useOnMount = (callback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};

export default useOnMount;
